__turbopack_context__.v({
  "labelSkeleton": "BHs_DG_labelSkeleton",
});
